/** @format */

import { Component, OnInit, Input, EventEmitter, Output, ElementRef } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UploadAttachmentsPayload } from 'src/app/models/attachment';
import { takeUntil, takeWhile } from 'rxjs/operators';

@Component({
    selector: 'app-add-attachments',
    templateUrl: './add-attachments.component.html',
    styleUrls: ['./add-attachments.component.scss'],
    standalone: false
})
export class AddAttachmentsComponent implements OnInit {
  @Input() header: string;
  @Input() fileFieldID: string;
	@Input() isCityworksRequest: boolean;
  @Output() uploadAttachmentsPayload = new EventEmitter<UploadAttachmentsPayload>();

  isIE = /msie\s|trident\//i.test(window.navigator.userAgent);

  formGroup: UntypedFormGroup;

  modal: NgbModalRef = null;
  uploadDisabled = true;
  uploading = false;

  constructor(private modalService: NgbModal) { }
  ngOnInit(): void {
    this.formGroup = new UntypedFormGroup({
      files: new UntypedFormControl([]),
      description: new UntypedFormControl()
    });
  }

  open(modal: any) {
    this.uploading = false;
    this.uploadDisabled = true;
    this.formGroup.get('files').setValue([]);
    this.formGroup.get('description').setValue('');
    this.modal = this.modalService.open(modal, { backdrop: 'static' });
  }

  onFileUpdate(file: File[]) {
    if (file.length > 0) {
      this.uploadDisabled = false;
    } else {
      this.uploadDisabled = true;
    }
  }

  upload() {
    this.uploading = true;
    this.uploadDisabled = true;
    this.uploadAttachmentsPayload.emit({
      caseNo: '',
      attachment: this.formGroup.value['files'],
      modal: this.modal,
      postUploadActions: [],
      description: this.formGroup.value['description'],
    });
  }

  close() {
    if (this.modal) {
      this.modal.close();
    }
  }
  dismiss() {
    if (this.modal) {
      this.modal.dismiss();
    }
  }
}
